<template>
    <div class="page-access page-content">
        <PageHeader title="对接文档"/>
        <div class="page-scroll-box">
            <div class="row">
                <div class="typeItem">
                    <i class="icon-android-sdk"/>
                    <div class="btn-box">
                        <div class="name">趣盟Android SDK</div>
                        <div class="oth">版本号: {{ getVersion() }}</div>
                        <div class="oth">更新时间: {{ getUpdateTime() }}</div>
                        <div class="oth">SDK开发者：{{ getCompanyName() }}</div>
                        <div class="oth">
                            主要功能：提供广告的拉取和展示功能，支持原生广告,激励视频广告，插屏广告和开屏广告，使用灵活的变现策略组合和利用算法优化广告效果，为开发者提供流量变现服务。
                        </div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goAndroidDocs">接入文档</a>
                            <!--<a class="btn-show" @click="goAndroidSdkDownload">下载SDK</a>-->
                            <a class="btn-show" @click="goPrivacy" v-if="checkHaiLiang()">隐私政策</a>
                            <a class="btn-show" @click="goCompliance('android')" v-if="checkHaiLiang()">合规使用说明</a>
                        </div>
                    </div>
                </div>
                
                <div class="typeItem">
                    <i class="icon-ios-sdk"/>
                    <div class="btn-box">
                        <div class="name">趣盟iOS SDK</div>
                        <div class="oth">版本号: {{ content.ios.version }}</div>
                        <div class="oth">更新时间: {{ content.ios.updateTime }}</div>
                        <div class="oth">SDK开发者：{{ getCompanyName() }}</div>
                        <div class="oth">
                            主要功能：提供广告的拉取和展示功能，支持原生广告,激励视频广告，插屏广告和开屏广告，使用灵活的变现策略组合和利用算法优化广告效果，为开发者提供流量变现服务。
                        </div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goIosDocs">接入文档</a>
                            <a class="btn-show" @click="goIosSdkDownload">下载SDK</a>
                            <a class="btn-show" @click="goPrivacy" v-if="checkHaiLiang()">隐私政策</a>
                            <a class="btn-show" @click="goCompliance('ios')" v-if="checkHaiLiang()">合规使用说明</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="typeItem">
                    <i class="icon-data"/>
                    <div class="btn-box">
                        <div class="name">数据查询API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goDataDetail">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
                <div class="typeItem">
                    <i class="icon-ad-slot"/>
                    <div class="btn-box">
                        <div class="name">流量管理API</div>
                        <div class="oth">版本号: 1.2.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goAdSlotDetail">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="typeItem" v-if="previewDocsVisible">
                    <i class="icon-preview-docs"/>
                    <div class="btn-box">
                        <div class="name">先审后投API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goPreviewDocs">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
                <div class="typeItem" v-if="reviewDocsVisible">
                    <i class="icon-review-docs"/>
                    <div class="btn-box">
                        <div class="name">先投后审API</div>
                        <div class="oth">版本号: 1.0.0</div>
                        <div class="oth">&nbsp;</div>
                        <div class="btn-row">
                            <a class="btn-show" @click="goReviewDocs">接入文档</a>
                            <a class="btn-show" @click="getToken">查看密钥</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <el-dialog :visible.sync="visibleIosDownload" title="趣盟iOS SDK下载" width="500px">
            <el-form label-position="right" label-width="180px" size="mini">
                <el-form-item label="推荐使用">
                    <el-button type="text" @click="goIosSdkDownloadAction(content.ios.downloadUrlQuMeng)"
                               style="padding-top: 5px;font-size: 16px;">趣盟 SDK(QuMengAdSDK)
                    </el-button>
                </el-form-item>
                <el-form-item label="备选">
                    <el-button type="text" @click="goIosSdkDownloadAction(content.ios.downloadUrlQM)"
                               style="padding-top: 3px;font-size: 14px;">趣盟 SDK(QMAdSDK)
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import {isHL} from '@/common/utils';
import axios from 'axios';
import { getUserInfo } from '@/apis/login';

export default {
    data() {
        return {
            userInfo: {},
            visibleIosDownload: false,
            content: {
                android: {},
                androidHL: {},
                ios: {}
            },
            
            previewDocsVisible: false, // 先审后投
            reviewDocsVisible: false, // 先投后审
        }
    },
    components: {
        PageHeader,
    },
    methods: {
        async init() {
            axios.get('https://docs.qttunion.com/android_sdk/qumeng_sdk_ios_android.json').then(res => {
                this.content.android = res.data.android[0];
                this.content.androidHL = res.data.androidHL[0];
                this.content.ios = res.data.ios[0];
            }).catch(err => {
                console.error('err >>> ', err);
            });
            
            const userInfo = await getUserInfo({});
            if (userInfo && userInfo.data && userInfo.data.auth) {
                this.previewDocsVisible = userInfo.data.auth.preview_auth === 1;
                this.reviewDocsVisible = userInfo.data.auth.review_auth === 1;
            }
        },
        
        checkHaiLiang() {
            return !isHL();
        },
        getCompanyName() {
            if (isHL()) return '上海趣圈圈信息科技有限公司';
            return '上海芸晞信息科技有限公司';
        },
        getVersion() {
            if (isHL()) return this.content.androidHL.version;
            return this.content.android.version;
        },
        getUpdateTime() {
            if (isHL()) return this.content.androidHL.updateTime;
            return this.content.android.updateTime;
        },
        
        // 隐私政策
        goPrivacy() {
            window.open('https://docs.qttunion.com/privacy/common/privacy-agreement.html');
        },
        
        // 合规使用说明
        goCompliance(type) {
            let url = type === 'android' ? 'https://docs.qttunion.com/privacy/common/5-developer_guider.html' : 'https://docs.qttunion.com/privacy/common/developer_guider_ios.html';
            window.open(url);
        },
        
        // android
        goAndroidDocs() {
            window.open(isHL() ? 'https://docs.qquanquan.com/android_sdk/hailiang.html' : 'https://docs.qttunion.com/android_sdk/qumeng.html')
        },
        goAndroidSdkDownload() {
            if (isHL()) {
                window.open(this.content.androidHL.downloadUrl);
            } else {
                window.open(this.content.android.downloadUrl);
            }
        },
        
        // ios
        goIosDocs() {
            window.open('https://docs.qttunion.com/ios_sdk/qumeng.html');
        },
        goIosSdkDownload() {
            this.visibleIosDownload = true;
        },
        goIosSdkDownloadAction(url) {
            window.open(url);
        },
        
        goDataDetail() {
            window.open(`${origin}/api.html`)
        },

        // 先审后投文档
        goPreviewDocs() {
            window.open(`${origin}/preview_docs.html`)
        },

        // 先投后审文档
        goReviewDocs() {
            window.open(`${origin}/review_docs.html`)
        },

        getToken() {
            const userInfo = this.$ls.get('userInfo')
            const token = userInfo.secret_key;
            this.$alert(token, '查看秘钥', {
                confirmButtonText: '复制',
            }).then(() => {
                this.$copyText(token).then(
                    () => {
                        this.$message.success('已复制到粘贴板');
                    },
                    () => {
                        this.$message.error('当前浏览器不支持复制');
                    }
                );
            }).catch(() => {
            });
        },
        
        goAdSlotDetail() {
            window.open(`${origin}/adslot_api.html`)
        }
    },
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";

.page-access {
    & .page-scroll-box {
        & .row {
            margin-bottom: 20px;
            display: flex;
            
            & .typeItem {
                margin-right: 20px;
                padding-bottom: 10px;
                width: 48%;
                //max-height: 120px;
                overflow: hidden;
                display: flex;
                align-items: flex-start;
                border-radius: 4px;
                border: 1px solid #E3E7ED;
                
                & .icon-android-sdk, & .icon-ios-sdk, & .icon-data, & .icon-ad-slot, & .icon-preview-docs, & .icon-review-docs {
                    margin-top: 10px;
                    margin-left: 10px;
                    width: 62px;
                    height: 62px;
                }
                
                & .icon-android-sdk {
                    display: inline-block;
                    background-image: url('./images/icon_android_sdk.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-ios-sdk {
                    display: inline-block;
                    background-image: url('./images/icon_ios_sdk.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-data {
                    display: inline-block;
                    background-image: url('./images/icon_data.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-ad-slot {
                    display: inline-block;
                    background-image: url('./images/icon_ad_slot.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-preview-docs {
                    display: inline-block;
                    background-image: url('./images/icon_preview_docs.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .icon-review-docs {
                    display: inline-block;
                    background-image: url('./images/icon_review_docs.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                
                & .name {
                    margin-top: 10px;
                }
                
                .btn-box {
                    display: flex;
                    flex-direction: column;
                    margin-left: 8px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    color: #303133;
                    line-height: 22px;
                    width: calc(100% - 90px);
                    
                    & .btn-row {
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        
                        & .btn-show {
                            &:last-child {
                                margin-right: 0;
                            }
                            
                            margin-top: 6px;
                            margin-right: 15px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #4F90FF;
                            line-height: 20px;
                            cursor: pointer;
                        }
                    }
                }
                
                & .oth {
                    font-family: "arial";
                    font-size: 12px;
                    font-weight: 400;
                    color: #999;
                    
                    & span {
                        margin: 0 8px;
                    }
                }
            }
        }
    }
}

</style>
